import type { VoiceCommandResult } from './voiceCommandClient';

const STORAGE_KEY = 'voicePendingDocumentFlow';

export interface PendingDocumentFlow {
  intent: string;
  customer_name?: string;
  supplier_name?: string;
  contact_id?: number;
  missing_entity?: string;
  gathering_items: boolean;
  items?: Array<{
    description: string;
    quantity: number;
    unit_price: number;
    tax_rate?: number;
  }>;
}

export function storePendingDocumentFlow(result: VoiceCommandResult): void {
  const gatheringItems = result.phase === 'gathering_items'
    || result.data?.gathering_items === true
    || result.data?.missing_entity?.startsWith('item_')
    || result.data?.missing_entity === 'more_items';

  if (!gatheringItems) return;

  const intent = result.data?.intent
    || result.conversation_state?.original_intent
    || result.conversation_state?.current_intent
    || 'create_quote';

  const pending: PendingDocumentFlow = {
    intent,
    gathering_items: true,
    missing_entity: result.data?.missing_entity || result.nextQuestion || 'item_description',
    customer_name: typeof result.data?.customer_name === 'string'
      ? result.data.customer_name
      : undefined,
    supplier_name: typeof result.data?.supplier_name === 'string'
      ? result.data.supplier_name
      : undefined,
    contact_id: typeof result.data?.contact_id === 'number' ? result.data.contact_id : undefined,
    items: Array.isArray(result.data?.items) ? result.data.items : [],
  };

  if (!pending.customer_name && !pending.supplier_name && result.message) {
    const match = result.message.match(/(?:Great\s*[—-]\s*)?(?:quote|invoice|bill)\s+for\s+(.+?)\.\s/i);
    if (match?.[1]) {
      pending.customer_name = match[1].trim();
    }
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
}

export function getPendingDocumentFlow(): PendingDocumentFlow | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PendingDocumentFlow;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearPendingDocumentFlow(): void {
  localStorage.removeItem(STORAGE_KEY);
}
